import { reauthenticateWithPopup } from "firebase/auth";
import { auth, googleProvider } from "@/config/firebase";

function requireOperator(uid: string) {
  const user = auth.currentUser;
  if (!user || user.uid !== uid) {
    throw new Error("Your sign-in changed. Reopen this case before continuing.");
  }
  return user;
}

export async function deletionReadToken(uid: string): Promise<string> {
  const token = await requireOperator(uid).getIdToken();
  requireOperator(uid);
  return token;
}

/** Refreshing an ID token does not refresh auth_time; reauthenticate the same operator. */
export async function deletionMutationToken(uid: string): Promise<string> {
  const user = requireOperator(uid);
  let result = await user.getIdTokenResult();
  requireOperator(uid);
  const age = Date.now() - Date.parse(result.authTime);
  if (!Number.isFinite(age) || age < -30_000 || age >= 240_000) {
    try {
      await reauthenticateWithPopup(user, googleProvider());
    } catch {
      throw new Error("Sign-in was not confirmed. No action was submitted. Please try again.");
    }
    requireOperator(uid);
    result = await user.getIdTokenResult(true);
  }
  requireOperator(uid);
  const verifiedAge = Date.now() - Date.parse(result.authTime);
  if (!Number.isFinite(verifiedAge) || verifiedAge < -30_000 || verifiedAge >= 300_000) {
    throw new Error("Please sign in again before recording this decision.");
  }
  return result.token;
}
